var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-wrapper"},[_c('div',{staticClass:"progress-container"},[_c('div',{staticClass:"progress-bar",style:(_vm.progressStyle)})]),_c('div',{staticClass:"progress-labels"},[_c('span',[_vm._v(_vm._s(_vm.qualification?.current_qualification?.name))]),_c('span',[_vm._v(_vm._s(_vm.qualification?.next_qualification?.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }